import { createFileRoute } from '@tanstack/react-router';
import { ServiceUsageDetailRoute } from '@/pages/admin/service-usage/detail-route';

/** Deep link ai volumi di un tenant: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute(
  '/admin/_layout/service-usage/_layout/$tenantId'
)({
  component: ServiceUsageDetailRouteComponent,
});

function ServiceUsageDetailRouteComponent() {
  const { tenantId } = Route.useParams();

  return <ServiceUsageDetailRoute tenantId={tenantId} />;
}
